// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11pY9","right":"styles_right__1AkqN"};